export var CardState;
(function (CardState) {
    CardState[CardState["ACTIVE"] = 1] = "ACTIVE";
    CardState[CardState["ORDERED"] = 10] = "ORDERED";
    CardState[CardState["READY"] = 11] = "READY";
    CardState[CardState["PRINTED"] = 12] = "PRINTED";
    CardState[CardState["PREPARED"] = 13] = "PREPARED";
    CardState[CardState["TRANSPORT"] = 14] = "TRANSPORT";
    CardState[CardState["PREPARED_TO_PRINT"] = 15] = "PREPARED_TO_PRINT";
    CardState[CardState["INACTIVE"] = 400] = "INACTIVE";
    CardState[CardState["NOT_CONFIRMED"] = 401] = "NOT_CONFIRMED";
})(CardState || (CardState = {}));
export const CardStateTranslation = {
    [CardState.ACTIVE]: 'Aktywna',
    [CardState.ORDERED]: 'Zamówiona',
    [CardState.PRINTED]: 'Wydrukowana',
    [CardState.READY]: 'Gotowa do odbioru',
    [CardState.INACTIVE]: 'Unieważniona',
    [CardState.NOT_CONFIRMED]: 'Niepotwierdzona',
    [CardState.PREPARED]: 'Przygotowana',
    [CardState.PREPARED_TO_PRINT]: 'Przygotowana do druku',
    [CardState.TRANSPORT]: 'Przekazanie do punktu odbioru'
};
//# sourceMappingURL=cardState.enum.js.map